/**
 * Routini API — Management
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const RouteStopType = {
    PickUpPassenger: 'PickUpPassenger',
    DropOffPassenger: 'DropOffPassenger',
    PickUpAttendant: 'PickUpAttendant'
} as const;
export type RouteStopType = typeof RouteStopType[keyof typeof RouteStopType];

